import { render, staticRenderFns } from "./ExerciseList.vue?vue&type=template&id=763ecb02&scoped=true"
import script from "./ExerciseList.vue?vue&type=script&lang=js"
export * from "./ExerciseList.vue?vue&type=script&lang=js"
import style0 from "./ExerciseList.vue?vue&type=style&index=0&id=763ecb02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ecb02",
  null
  
)

export default component.exports